// extracted by mini-css-extract-plugin
export default {"text":"root_title-module__text___inw3e","picture":"root_title-module__picture___Qkza5"};